<template>
  <b-row>

    <b-overlay :show="showOverlay" rounded="sm">
    <b-card class="mt-2 col-12">
      <b-tabs>
        <b-tab
          v-for="tab in tabs"
          :key="tab.title"
          :title="tab.title"
          lazy
          @click.prevent="setActiveTabName(tab.mode)"
        >
          <b-col cols="12">
            <SearchFilter :mode="tab.mode" @handleSubmit="searchFilterSubmit" />
          </b-col>
        </b-tab>
      </b-tabs>
    </b-card>

    <b-col v-for="tab in activeTab" :id="tab" :key="tab" cols="12">
      <commonTable
        ref="tableCommon"
        :mode="tab"
        @handleSend="getManageDetail"
        @handleGroup="getManageGroup"
        @handleSelect="onSelectChange"
        @handleOverlay="setOverlay"
      />
    </b-col>

    <b-col cols="12">
      <b-card>
        <div class="container">
          <b-form-group label="ผู้ดูแลข้อมูลใหม่" class="mt-3">
            <vue-select
              label="text"
              :required="true"
              v-model="officerTransfer"
              :options="officerList"
              class=""
            />
          </b-form-group>
          <b-form-group label="ความเห็นเจ้าหน้าที่">
            <b-form-textarea
              id="offficerComment"
              placeholder="ความเห็นเจ้าหน้าที่"
              rows="6"
              v-model="comment"
            />
          </b-form-group>
          <div class="d-flex justify-content-end mt-2">
            <!-- <b-button variant="secondary" @click="onBackBtnClicked">
              ยกเลิก
            </b-button> -->
            <b-button variant="primary" @click="onTransferBtnClicked">
              แก้ไขผู้ดูแลข้อมูล
            </b-button>
          </div>
        </div>
      </b-card>
    </b-col>
    </b-overlay>
    <ModalTransferSubmit
      ref="modalTransferComponent"
      :complaints="selectComplaints"
      :comment="comment"
      :person="officerTransfer"
      @handle-submit="onTransferSubmit"
    />
  </b-row>
</template>

<script>
import {
  BRow,
  BCol,
  BTabs,
  BTab,
  BButton,
  BCard,
  BCardHeader,
  BCardBody,
  BFormGroup,
  BFormTextarea,
  BOverlay,
} from "bootstrap-vue";

import VueSelect from "vue-select";

import commonTable from "./components/commonTable.vue";
import SearchFilter from "./components/SearchFilter.vue";
import ModalTransferSubmit from "./components/ModalTransferSubmit.vue";

import * as viewStore from "@/store/api/screening/screening.js";
import * as storeMaster from "@/store/api/master/index.js";
import * as storeTransfer from "@/store/api/complaint/transfer.js";
import * as departmentRoleStore from "@/store/api/role/departmentRole.js";

import * as userData from "@/auth/localStorageUtils.js";

export default {
  components: {
    BRow,
    BCol,
    BButton,
    BTabs,
    BTab,
    BCard,
    BCardHeader,
    BCardBody,
    BFormGroup,
    BFormTextarea,
    commonTable,
    SearchFilter,
    viewStore,
    VueSelect,
    ModalTransferSubmit,
    BOverlay,
  },
  created() {
    this.getOfficerDepartment();
  },
  data() {
    return {
      tabs: [{ title: "รายการเรื่องร้องทุกข์", mode: "List" }],
      activeTab: ["List"],
      selectComplaints: [],
      officerTransfer: {},
      officerList: [],
      comment: "",
      showOverlay: false,
      department: {
        value: userData.selectedAdminDepartment(),
        text: "",
      },
    };
  },
  methods: {
    setOverlay(isShow) {
      this.showOverlay = isShow;
    },
    onTransferBtnClicked() {
      if (this.selectComplaints.length === 0) {
        this.$bvToast.toast("กรุณาเลือกรายการที่จะส่งต่อ", {
          title: `กรุณาเลือกรายการที่จะส่งต่ออย่างน้อย 1 รายการ`,
          variant: "danger",
          solid: false,
        });

        return;
      }

      this.$refs.modalTransferComponent.$refs["modal-transfer"].show();
    },
    onTransferSubmit() {
      const _this = this;

      const complaintGuids = this.selectComplaints.map(
        (value) => value.complaintId
      );

      console.log("complaintGuids", complaintGuids);

      const data = {
        //transferToUser: '7b221b40-7ed2-444c-8b17-e2f0f8da8f93',
        transferToUser: this.officerTransfer.value,
        userId: userData.userId(),
        comment: this.comment,
        complaints: this.selectComplaints,
      };

      storeTransfer
        .transferComplaint(data)
        .then((response) => {
          console.log("response", response);

          _this.$bvToast.toast("บันทึกข้อมูลสำเร็จ", {
            title: `ระบบได้บันทึกการแก้รายชื่อผู้ดูแลของท่านแล้ว`,
            variant: "success",
            solid: false,
          });

          setTimeout(function() {
            window.open(
              _this.$router.resolve({ name: "Transfer" }).href,
              "_self"
            );
          }, 500);
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    onSelectChange(selects) {
      this.selectComplaints = selects;
      console.log("this.selectComplaints", this.selectComplaints);
    },
    setActiveTabName(name) {
      this.activeTab = [];
      this.activeTab.push(name);
    },
    getManageDetail(id) {
      // let routeData = this.$router.resolve({name: 'LawScreeningManage', query: { id:id } });
      // window.open(routeData.href, '_blank');
    },
    getManageGroup(id) {
      // let routeData = this.$router.resolve({name: 'LawGroupdManage' });
      // window.open(routeData.href, '_blank');
      const routeData = this.$router.resolve({
        name: "ScreeningManage",
        query: { id },
      });
      window.open(routeData.href, "_blank");
    },
    searchFilterSubmit(params) {
      //console.log('searchFilterSubmit', params, )
      this.$refs.tableCommon[0].onSearchSubmit(params);
    },
    onBtnAddClicked() {
      window.open(
        this.$router.resolve({
          name: "servicecentercomplaint",
          query: { parentComponent: "screening" },
        }).href,
        "_self"
      );
    },
    getOfficerDepartment() {
      console.log("getOfficerDepartment");
      
      const _this = this;

      const params = {
        departmentId: _this.department.value,
      };

      departmentRoleStore
        .searchUser(params)
        .then(function(response) {
          // handle success
          console.log("response Transfer", response);

          var setDataList = [];

          response.data.data.forEach((o) => {
            var setData = {};
            setData.value = o.userId;
            setData.text = o.fName + " " + o.lName;

            setDataList.push(setData);
          });

          _this.officerList = setDataList;
          _this.officerTransfer = _this.officerList[0];

          _this.$forceUpdate();
        })
        .catch(function(error) {
          // handle error
          console.log("error", error);
        });

      // storeMaster
      //   .getOfficerInfos(userData.departmentId())
      //   .then(function(response) {
      //     var setDataList = [];

      //     response.data.data.forEach((o) => {
      //       var setData = {};
      //       setData.value = o.user_id;
      //       setData.text = o.title_name + " " + o.fname + " " + o.lname;

      //       setDataList.push(setData);
      //     });

      //     _this.officerList = setDataList;
      //     _this.officerTransfer = _this.officerList[0];
      //     //console.log('_this.officerTransfer', _this.officerTransfer, response.data.data)
      //     //_this.$forceUpdate();
      //   })
      //   .catch(function(error) {
      //     // handle error
      //     console.log("error", error);
      //   });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
